import { Link } from "react-router-dom";

const footerLinks = [
  { label: "首页", to: "/" },
  { label: "剧集剧情", to: "/category/drama" },
  { label: "角色介绍", to: "/category/characters" },
  { label: "影视资讯", to: "/category/news" },
  { label: "关于本站", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950 font-heading text-lg">
                妻
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                我妻子的一切
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-300">
              专注于电视剧《我妻子的一切》的影视内容分享，提供剧情介绍、角色分析与最新影视资讯，
              帮助观众更深入地理解这个关于婚姻与自我的故事。
            </p>
            <p className="mt-4 text-xs text-background-400">
              本站为影视内容演示站点，不提供视频播放、下载或在线支付功能。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">内容导航</h3>
            <ul className="mt-4 space-y-2.5">
              {footerLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系与反馈</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" />
                <span>contact@allaboutmywife.demo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base text-accent-400" />
                <span>内容编辑部 · 线上运营</span>
              </li>
              <li>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1 text-accent-400 transition-colors hover:text-accent-300"
                >
                  前往反馈页面
                  <i className="ri-arrow-right-line" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2023 我妻子的一切 · 影视内容分享站 · 本站内容均为演示数据</p>
          <p>仅供影迷学习交流使用 · All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}